module.exports = __webpack_public_path__ + "static/media/orchidsRadioLogo.5c547e54.png";